
const ErrorBlock = () => {
    return (
        <svg width="43" height="42" viewBox="0 0 43 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.9629 42C33.5609 42 42.9629 32.598 42.9629 21C42.9629 9.40202 33.5609 0 21.9629 0C10.3649 0 0.962891 9.40202 0.962891 21C0.962891 32.598 10.3649 42 21.9629 42Z" fill="#FAA86F"/>
            <path d="M32.4442 26.9047C35.8269 21.0457 33.8195 13.5537 27.9604 10.1709C22.1013 6.78818 14.6093 8.79565 11.2266 14.6547C7.84382 20.5138 9.85129 28.0058 15.7104 31.3885C21.5695 34.7713 29.0614 32.7638 32.4442 26.9047Z" stroke="#FFDB9B" stroke-width="5"/>
            <path d="M15.457 31.829L27.9579 10.1768" stroke="#FFDB9B" stroke-width="5"/>
        </svg>
    )
}

export default ErrorBlock;

